import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

const propTypes = {
  isOpen: PropTypes.bool,
  headerClassName: PropTypes.string,
  modalBody: PropTypes.node.isRequired,
  modalHeader: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  modalSize: PropTypes.oneOf(["sm", "lg", "xl"]),
  toggleModal: PropTypes.func.isRequired
};

const defaultProps = {
  isOpen: false,
  headerClassName: "",
  modalHeader: null,
  modalSize: null
};

const CommonModal = ({
  headerClassName,
  isOpen,
  modalBody,
  modalHeader,
  modalSize,
  toggleModal
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggleModal} size={modalSize}>
      <ModalHeader toggle={toggleModal} className={headerClassName}>
        {modalHeader}
      </ModalHeader>
      <ModalBody className="p-4">{modalBody}</ModalBody>
    </Modal>
  );
};

CommonModal.propTypes = propTypes;

CommonModal.defaultProps = defaultProps;

export default CommonModal;
